import { loadStripe } from '@stripe/stripe-js';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { FiLoader } from 'react-icons/fi';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '');

interface CheckoutButtonProps {
  cartItems?: any[];
  userId?: string;
  className?: string;
  shippingAddress?: {
    address: string;
    city: string;
    country: string;
    state: string;
    zip: string;
  };
  notes?: string;
  deliveryOption?: 'standard' | 'express';
  disabled?: boolean;
  text?: string;
  style?: React.CSSProperties;
}
const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:5000/api/v1';

export default function CheckoutButton({ cartItems, userId, className, shippingAddress, notes, deliveryOption = 'standard', fastPayFee = 0, disabled, text = 'Place Order', style }: CheckoutButtonProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault(); // Prevent form submission
    if (disabled) return; // Don't proceed if button is disabled
    try {
      setIsLoading(true);
      // Get the auth token from localStorage
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No authentication token found');
      }

      const normalizedDeliveryOption = deliveryOption === 'express' ? 'fast pay' : 'standard';
      const payloadCartItems = cartItems;


      const res = await fetch(`${apiUrl}/checkout/create-session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          cartItems: payloadCartItems,
          shippingAddress,
          notes,
          deliveryOption: normalizedDeliveryOption,
          deliveryType: normalizedDeliveryOption,
          fastPayFee
        }),
      });

      if (!res.ok) {
        const errorData = await res.json();
        console.error('[API Error]', errorData);
        throw new Error(errorData.message || 'Network response was not ok');
      }

      const { sessionId } = await res.json();

      const stripe = await stripePromise;

      console.log("strpie",sessionId)

      if (!stripe) {
        throw new Error('Stripe failed to load');
      }

      const { error } = await stripe.redirectToCheckout({ sessionId });

      if (error) {
        console.error('[Stripe Redirect Error]', error);
        throw error;
      }
    } catch (error) {
      console.error('[Checkout Error]', error);
      // Show error in a more user-friendly way
      toast.error(error instanceof Error ? error.message : 'An error occurred during checkout');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`${className} relative flex items-center justify-center gap-2`}
      disabled={isLoading || disabled}
      style={style}
    >
      {isLoading ? (
        <>
          <FiLoader className="animate-spin w-5 h-5" />
          <span>Processing...</span>
        </>
      ) : (
        text
      )}
    </button>
  );
} 
